var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPythIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#110F23;}\n\t.st1{fill:#E6DAFE;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497,384.3c0,31.2-25.2,56.4-56.4,56.4l0,0v56.4c62.3,0,112.8-50.6,112.8-112.9v0 c0-62.3-50.5-112.8-112.8-112.9c-19.8,0-39.2,5.2-56.4,15.1c-34.9,20.2-56.4,57.4-56.4,97.8v282.2l50.7,50.8l5.7,5.7V384.3 c-0.8-31.1,23.8-57.1,54.9-57.9s57.1,23.8,57.9,54.9C497,382.3,497,383.3,497,384.3L497,384.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.6,158.4c-41.1,0-79.6,11-112.8,30.2c-21.2,12.3-40.2,27.9-56.4,46.2C235,276,215,329.1,215,384.1v169.3 l56.4,56.4V384.1c-0.1-48.2,20.5-94.1,56.4-126.2c31-27.8,71.2-43.1,112.8-43.1c93.4,0,169.2,75.8,169.2,169.3 c0,93.5-75.8,169.3-169.2,169.3v56.4c124.6,0,225.6-101.1,225.6-225.7S565.2,158.4,440.6,158.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythIcon);
export default __webpack_public_path__ + "static/media/pyth_icon.c50499c70d1675f7697861aaacce31df.svg";
export { ForwardRef as ReactComponent };